export default __webpack_public_path__ + "static/media/pulse_avatar.03573faf.svg";